module.exports = __webpack_public_path__ + "static/privacy-8f6a84795987504d51abdf9a5436b72c.svg";